// ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ component: Component }) => {
    const { isLoggedIn } = useAuth(); 
   console.log("protectedlogin",isLoggedIn);
   
  
    return isLoggedIn ? <Component /> : <Navigate to="/" />;
  };

export default ProtectedRoute;
